export default __webpack_public_path__ + "static/media/restore-white-18dp.db3e5946.svg";